import Vue from 'vue';
import Router from 'vue-router';
import goTo from 'vuetify/lib/components/Vuetify/goTo';
import Home from '../views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/filme',
      name: 'movies',
      props: true,
      component: () => import('../views/Movies.vue'),
    },
    {
      path: '/film/:id',
      name: 'movie-detail',
      props: true,
      component: () => import('../views/MovieDetail.vue'),
    },
    {
      path: '/serien',
      name: 'tv-shows',
      props: true,
      component: () => import('../views/tvShows/TvShows.vue'),
    },
    {
      path: '/serie/:id',
      name: 'tv-show',
      props: true,
      component: () => import('../views/tvShows/TvShowDetail.vue'),
    },
    {
      path: '/serie/:id/staffel/:season_number',
      name: 'season-detail',
      props: true,
      component: () => import('../views/tvShows/SeasonDetail.vue'),
    },
    {
      path: '/im-kino',
      name: 'now',
      component: () => import('../views/Now.vue'),
    },
    {
      path: '/kommend',
      name: 'up-comming',
      component: () => import('../views/UpComming.vue'),
    },
    {
      path: '/beliebt',
      name: 'popular',
      component: () => import('../views/Popular.vue'),
    },

    {
      path: '/beste-bewertungen',
      name: 'top-rated',
      component: () => import('../views/Top.vue'),
    },
    {
      path: '/personen',
      name: 'people',
      component: () => import('../views/People.vue'),
    },
    {
      path: '/person/:id',
      name: 'person-detail',
      props: true,
      component: () => import('../views/PersonDetail.vue'),
    },

    {
      path: '/favoriten',
      name: 'bookmarks',
      props: true,
      component: () => import('../views/Bookmarks.vue'),
    },
    {
      path: '/erweiterte-suche',
      name: 'param-search',
      props: true,
      component: () => import('../views/ParamSearch.vue'),
    },
    {
      path: '/suche',
      name: 'search',
      props: true,
      component: () => import('../views/Search.vue'),
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('../views/Test.vue'),
    },
    {
      path: '*',
      name: '404',
      component: () => import('../views/404.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);

    // let position = {
    //   x: 0,
    //   y: 0,
    // };

    // if (savedPosition) {
    //   position = savedPosition;
    // }

    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve(position);
    //   }, 300);
    // });
  },
});
